/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Event} from "../models/event";
import {EventService} from "../services/event.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class EventsResolver implements Resolve<Event[]> {

  constructor(
    private mEventService: EventService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Event[]> {
    try {
      return await this.mEventService.getAllEvents();
    } catch (error) {
      console.error("Problem resolving Events... Error: " + error, error);
    }
  }

}
